import React from "react";
import { renderDate } from "../../../helpers/HelperMethods";

const DeletePowerAppDialogContent = ({powerApp}) => {
    return (
        <div>
            {
                powerApp.lastLaunched && 
                <div>Please note that this element was last used on <b>{renderDate(powerApp.lastLaunched)}</b>.</div>
            }
            {/* <div>
                A backup will be kept for <b>6 months</b> and permanently deleted afterward.
            </div> */}
            <div>
                Do you want to proceed?
            </div>
        </div>
    )
}

export default DeletePowerAppDialogContent;



// WEBPACK FOOTER //
// ./src/components/EditSite/PowerAppEditElements/DeletePowerAppDialogContent.js